import Box from "./Box";
import DashHeading from "./DashHeading";
import FullWidth2UpGrid from "./FullWidth2UpGrid";
import HeadingSmall from "./HeadingSmall";
import LargeHeadingImageSection from "./LargeHeadingImageSection";
import PropTypes from "prop-types";
import React from "react";
import RichTextLarge from "./RichTextLarge";
import TwoColBox from "./TwoColBox";

function AboutRecycle({
  image,
  mobImage,
  subheading,
  callout1,
  text1,
  image1,
  image2,
  callout2,
  text2,
  sectionId,
}) {
  return (
    <Box id={sectionId}>
      <LargeHeadingImageSection
        heading="Reskinned <b><i>Recycle</i></b>"
        image={image}
        mobImage={mobImage}
        bg="mint"
      >
        <DashHeading heading={subheading} />
        <Box mt={[40, null, 50, null]} mb={[40, null, 100, null]}>
          <TwoColBox
            col1={<HeadingSmall>{callout1}</HeadingSmall>}
            col2={<RichTextLarge>{text1}</RichTextLarge>}
          />
        </Box>
        <FullWidth2UpGrid image1={image1} image2={image2} />
        <Box mt={[40, null, 100, null]} pb={[30, null, 40, null]}>
          <TwoColBox
            col1={<HeadingSmall>{callout2}</HeadingSmall>}
            col2={<RichTextLarge>{text2}</RichTextLarge>}
          />
        </Box>
      </LargeHeadingImageSection>
    </Box>
  );
}

export default AboutRecycle;

AboutRecycle.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  mobImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  callout1: PropTypes.string.isRequired,
  text1: PropTypes.string.isRequired,
  callout2: PropTypes.string.isRequired,
  text2: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  image1: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  image2: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  sectionId: PropTypes.string.isRequired,
};
